import { render, staticRenderFns } from "./bLogoSelect.vue?vue&type=template&id=d6f526a0"
import script from "./bLogoSelect.vue?vue&type=script&lang=js"
export * from "./bLogoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports